const buildUrl = (serverAddress, port) => {
  const hasProtocol = /^https?:\/\//i.test(serverAddress)
  const normalizedAddress = hasProtocol ? serverAddress : `http://${serverAddress}`
  const url = new URL(normalizedAddress)

  if (!url.port && port) {
    url.port = String(port)
  }

  url.pathname = '/api/public/core/v1/flash/items'
  url.search = ''
  url.hash = ''

  return url.toString()
}

const sendFlash = async (serverAddress, port, auth_key, eans, duration) => {
  try {
    await fetch(buildUrl(serverAddress, port), {
      method: 'POST',
      mode: 'no-cors',
      headers: {
        accept: '*/*',
        Authorization: auth_key,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        configuration: { duration, realtime: true, color: '#ff00ff', flashType: 10 },
        itemIds: eans,
      }),
    })
    return true
  } catch(error) {
    return false
  }
}

const sendFlashAndroid = async (serverAddress, port, auth_key, eans, duration) => {
  try {
    const android = typeof window !== 'undefined' ? window.Android : null

    if (!android || typeof android.pricerFlashItem !== 'function') {
      return false
    }

    return !!android.pricerFlashItem(
      serverAddress,
      Number(port),
      auth_key,
      JSON.stringify(Array.isArray(eans) ? eans : []),
      Number(duration),
    )
  } catch(error) {
    return false
  }
}

const sendFlashSmart = (serverAddress, port, auth_key, eans, duration) => {
  const android = typeof window !== 'undefined' ? window.Android : null
  const hasAndroidBridge = android && typeof android.pricerFlashItem === 'function'
  console.log('Using flash method:', hasAndroidBridge ? 'Android Bridge' : 'Fetch API')
  return hasAndroidBridge
    ? sendFlashAndroid(serverAddress, port, auth_key, eans, duration)
    : sendFlash(serverAddress, port, auth_key, eans, duration)
}

const flashItems = (serverAddress, port, auth_key, eans) => sendFlashSmart(serverAddress, port, auth_key, eans, 60)
const stopItems = (serverAddress, port, auth_key, eans) => sendFlashSmart(serverAddress, port, auth_key, eans, 0)

export { flashItems, stopItems }
